"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const theme_1 = __importDefault(require("../../../styles/theme"));
const primaryButton_1 = __importDefault(require("../../../components/primaryButton/primaryButton"));
const checkInput_1 = __importDefault(require("../../../components/checkInput/checkInput"));
const labelButton_1 = __importDefault(require("../../../components/labelButton/labelButton"));
const systemData_1 = require("../../../utils/systemData");
const loanApplicationSlice_1 = require("../loanApplicationSlice");
const screenConstants_1 = require("../../../constants/screenConstants");
const useAppNavigation_1 = __importDefault(require("../../../hooks/useAppNavigation"));
const openExternalLink_1 = __importDefault(require("../../../components/openExternalLink/openExternalLink"));
const store_1 = require("../../../store");
const homeSlice_1 = require("../../home/homeSlice");
const text_1 = __importStar(require("../../../components/text/text"));
const pressableElement_1 = __importDefault(require("../../../components/pressables/pressableElement"));
const constants_1 = require("../../../constants/constants");
const icon_1 = require("../../../components/icon/icon");
const navContainer_1 = __importDefault(require("../../../components/navContainer/navContainer"));
const styles_1 = __importDefault(require("../../../styles/styles"));
const summaryBox_1 = __importDefault(require("../../../components/summaryRow/summaryBox"));
const analytics_1 = require("../../../utils/analytics/analytics");
const LoanApplicationSummaryFields = ({ loanApplication, loanApplicationId, loanTerms, }) => {
    const navigation = (0, useAppNavigation_1.default)();
    const dispatch = (0, store_1.useAppDispatch)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const [agreeStatus, setAgree] = (0, react_1.useState)([]);
    const [showErrorMessage, setShowErrorMessage] = (0, react_1.useState)(false);
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const submitForm = async () => {
        setIsLoading(true);
        if (agreeStatus.length === 1) {
            if (react_native_1.Platform.OS !== 'web') {
                (0, systemData_1.requestReadContactsPermission)();
            }
            setShowErrorMessage(false);
            const payload = {
                use_of_proceeds: loanApplication.use_of_proceeds,
                request_amount: loanApplication.request_amount,
                request_tenor_days: loanApplication.request_tenor_days,
                request_repayment_periodicity: loanApplication.request_repayment_periodicity,
                can_provide_cheque: loanApplication.can_provide_cheque,
            };
            const result = await dispatch((0, loanApplicationSlice_1.sendLoanApplication)(payload));
            logEventWithExtraProperties('api_call', {
                name: 'submit_loan_application',
                status: 'submitted',
                location: 'screen_LoanApplicationSummaryFields',
            });
            if ((0, toolkit_1.isFulfilled)(result)) {
                logEventWithExtraProperties('api_call', {
                    name: 'submit_loan_application',
                    status: 'success',
                    location: 'screen_LoanApplicationSummaryFields',
                });
                setIsLoading(false);
                navigation.reset({ index: 0, routes: [{ name: screenConstants_1.HOME_SCREEN }] });
                const messages = result.payload.map((missing_data) => ({
                    title: '',
                    message: missing_data.message,
                    iconType: icon_1.ALERT_ICON,
                    iconColor: '',
                    iconSize: 55,
                    buttonText: missing_data.button_text,
                    actionButton: () => navigation.navigate(missing_data.navigate),
                }));
                messages.push({
                    title: 'Thank you for applying',
                    message: 'We will contact you briefly with the next steps. Please pay attention to your email inbox and visit this app every day to be up to date with your application.',
                    iconType: icon_1.APPMESSAGE_CHECK_CIRCLE,
                    iconColor: '',
                    iconSize: 55,
                    buttonText: 'Continue',
                    actionButton: () => navigation.navigate(screenConstants_1.HOME_SCREEN),
                });
                dispatch((0, homeSlice_1.addMessages)(messages));
                dispatch((0, homeSlice_1.showMessage)());
            }
            else {
                logEventWithExtraProperties('api_call', {
                    name: 'submit_loan_application',
                    status: 'fail',
                    location: 'screen_LoanApplicationSummaryFields',
                });
                setErrors(result.payload);
            }
        }
        else {
            setShowErrorMessage(true);
        }
        setIsLoading(false);
    };
    const summaryData = [
        {
            field: 'Loan Amount',
            fieldName: 'loanAmount',
            value: loanApplication.request_amount,
        },
        {
            field: 'Reason of Loan',
            value: Number(loanApplication.use_of_proceeds),
            fieldName: 'loanReason',
        },
        {
            field: 'Tenor Days',
            value: Number(loanApplication.request_tenor_days),
            fieldName: 'tenor',
        },
        {
            field: 'Payment Periodicity',
            value: Number(loanApplication.request_repayment_periodicity),
            fieldName: 'periodicity',
        },
        {
            field: 'Can Provide Cheques',
            value: loanApplication.can_provide_cheque.toString() === '1' ? 'Yes' : 'No',
            fieldName: 'canProvideCheque',
        },
    ];
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, childrenTitle: "Loan Summary", specialArrow: true, specialArrowTargetScreen: loanApplicationId === null ? screenConstants_1.NEW_LOAN_APPLICATION_SCREEN : screenConstants_1.HOME_SCREEN, footer: loanApplicationId === null && (react_1.default.createElement(primaryButton_1.default, { disabled: false, title: "Apply For a Loan", onPress: submitForm, eventName: "loanApplicationSummary_applyForLoan" })) },
        react_1.default.createElement(summaryBox_1.default, { title: "Summary", data: summaryData }),
        loanTerms && react_1.default.createElement(summaryBox_1.default, { title: "Loan Terms", data: loanTerms }),
        loanApplicationId === null && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.centerChildHorizontalVertical] }, showErrorMessage ? (react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_CRITICAL }, t('loanApplicationSummaryFields.have_to_agree'))) : null),
            react_1.default.createElement(checkInput_1.default, { choices: [
                    {
                        value: '1',
                        label: (react_1.default.createElement(labelButton_1.default, { title: "TERMS & CONDITIONS", textColor: theme_1.default.colors.COLOR_PRIMARY, onPress: () => (0, openExternalLink_1.default)({
                                navigation,
                                url: 'https://lendigo.ng/terms-conditions/',
                                webViewData: {
                                    sourcePage: screenConstants_1.LOAN_APPLICATION_SUMMARY_SCREEN,
                                    sourceScreen: 'loanAppSummary',
                                    name: 'termsAndConditions',
                                    title: 'Terms and conditions',
                                },
                            }), textBeforeLink: `I have reviewed and agree with the `, eventName: "lendigo_terms_url" })),
                        checked: false,
                    },
                ], setSelected: setAgree, selected: agreeStatus, error: "" }))),
        loanTerms && (react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_GRAY }, t('loanApplicationSummaryFields.final_loan_terms')),
            react_1.default.createElement(pressableElement_1.default, { onPress: () => (0, openExternalLink_1.default)({
                    navigation,
                    url: constants_1.LOAN_TERMS_WEBSITE_URL,
                    webViewData: {
                        sourcePage: screenConstants_1.LOAN_APPLICATION_SUMMARY_SCREEN,
                        sourceScreen: 'loanAppSummary',
                        name: 'loanTermsSite',
                        title: 'Loan Application Terms',
                    },
                }), style: [styles_1.default.flexOne, styles_1.default.flexDirectionRow], eventName: "lendigo_terms_url" },
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
                    react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE, color: theme_1.default.colors.COLOR_PRIMARY }, t('loanApplicationSummaryFields.more_information'))))))));
};
LoanApplicationSummaryFields.defaultProps = {
    loanTerms: undefined,
};
exports.default = LoanApplicationSummaryFields;
